// @ts-nocheck

import cancelDE from './annule_de.png';
import cancelEN from './annule_en.png';
import cancelES from './annule_es.png';
import cancelFR from './annule_fr.png';
import cancelPT from './annule_pt.png';
import cashout from './cashout.png';
import liveDE from './encours_de.png';
import liveEN from './encours_en.png';
import liveES from './encours_es.png';
import liveFR from './encours_fr.png';
import livePT from './encours_pt.png';
import winDE from './gagne_de.png';
import winEN from './gagne_en.png';
import winES from './gagne_es.png';
import winFR from './gagne_fr.png';
import winPT from './gagne_pt.png';
import lostDE from './perdu_de.png';
import lostEN from './perdu_en.png';
import lostES from './perdu_es.png';
import lostFR from './perdu_fr.png';
import lostPT from './perdu_pt.png';

export default {
  FR: {
    RUNNING: liveFR,
    WINNING: winFR,
    LOST: lostFR,
    CANCELLED: cancelFR,
    CASHOUT: cashout,
  },
  EN: {
    RUNNING: liveEN,
    WINNING: winEN,
    LOST: lostEN,
    CANCELLED: cancelEN,
    CASHOUT: cashout,
  },
  DE: {
    RUNNING: liveDE,
    WINNING: winDE,
    LOST: lostDE,
    CANCELLED: cancelDE,
    CASHOUT: cashout,
  },
  ES: {
    RUNNING: liveES,
    WINNING: winES,
    LOST: lostES,
    CANCELLED: cancelES,
    CASHOUT: cashout,
  },
  PT: {
    RUNNING: livePT,
    WINNING: winPT,
    LOST: lostPT,
    CANCELLED: cancelPT,
    CASHOUT: cashout,
  },
};
